const DEFAULT_PAGE_SIZE = 12;

const state = () => ({
  auctions: [],
  filters: {
    query: '',
    pagination: {
      size: 12,
      from: 0,
      next: null,
    },
  },
  routeAuctionViewedFrom: null,
  DEFAULT_PAGE_SIZE,
});

export default state;
